<template>
  <header>
    <nav class="navbar navbar-expand-md" aria-label="Offcanvas navbar large">
      <div class="container-fluid">
        <router-link to="/Home" class="navbar-brand">
          <img :src="$t('Header.BrandLogo')" alt="Brand Logo" class="img-fluid" />
        </router-link>

        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-bs-toggle="offcanvas"
          data-bs-target="#navbar-Nav" 
          aria-controls="navbar-Nav" 
          aria-label="Toggle navigation"
          v-if="!$route.meta.hideNav"
        ></button>
        <div class="offcanvas offcanvas-end text-bg-dark" tabindex="-1" id="navbar-Nav" aria-labelledby="navbar-NavLabel" v-if="!$route.meta.hideNav">
          <div class="offcanvas-header">
            <router-link to="/Home" class="navbar-brand">
              <img :src="$t('Header.BrandLogo')" alt="Brand Logo" class="img-fluid" />
            </router-link>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
        <div class="offcanvas-body">
          <ul class="navbar-nav justify-content-end flex-grow-1 pe-3">
            <li class="nav-item">
              <router-link to="/Home" class="nav-link" @click="closeMenu">
                {{ $t('Header.HomeTab') }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/Upload" class="nav-link ms-md-3" @click="closeMenu">
                {{ $t('Header.UploadTab') }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/Support" class="nav-link ms-md-3" @click="closeMenu">
                {{ $t('Header.SupportTab') }}
              </router-link>
            </li>
            <li class="nav-item">
                <a href="https://www.wkkellogg.com/where-to-buy" target="_blank" class="nav-link ms-md-3">
                  <span v-html="$t('Header.BuyTab')"></span>
                </a>
            </li>
          </ul>
        </div>
      </div>
      </div>
    </nav>
  </header>

  <banner></banner>
</template>


<script>
import banner from '../UI/Banner.vue';
import { useI18n } from 'vue-i18n';
import { ref, watch, onMounted } from 'vue';
import { loadLocaleMessages } from '@/main.js';

export default {
  components: { banner },
  setup() {
    const { locale, t } = useI18n();
    const currentLang = ref(locale.value);
    const isCollapsed = ref(false); // ✅ Define state for toggle

    const toggleCollapse = () => {
      isCollapsed.value = !isCollapsed.value;
    };

    const closeMenu = () => {
      isCollapsed.value = false;
    };

    const changeLanguage = async (lang) => {
      if (currentLang.value === lang) return;

      await loadLocaleMessages(lang);
      locale.value = lang;
      localStorage.setItem('locale', lang);
      currentLang.value = lang;
      injectGTM();
    };

    watch(locale, (newLocale) => {
      currentLang.value = newLocale;
    });

    onMounted(() => {
      injectGTM();
    });

    const injectGTM = () => {
      const gtmId = t('gtmId');
      if (!gtmId) return;

      document.querySelectorAll("[data-gtm]").forEach(el => el.remove());

      const script = document.createElement("script");
      script.setAttribute("data-gtm", gtmId);
      script.innerHTML = `
        (function (w, d, s, l, i) {
          w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
          var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; 
          j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; 
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', '${gtmId}');
      `;
      document.head.appendChild(script);

      const noscript = document.createElement("noscript");
      noscript.setAttribute("data-gtm", gtmId);
      noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      document.body.prepend(noscript);
    };

    return { currentLang, changeLanguage, isCollapsed, toggleCollapse, closeMenu };
  },
};
</script>
